import axios from "axios";

export function getCurrentRecommandation() {
    return axios({
        method: "get",
        url: `${process.env.REACT_APP_API_URL}/recommandation/current`,
        withCredentials: true,
    });
}
